import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const DEFAULT_USE_CASE_OPTIONS = [
  { id: 'Build faster with code and AI', label: 'Build faster with code and AI' },
  { id: 'Embed automation in your product', label: 'Embed automation in your product' },
  { id: 'Power AI agents across systems', label: 'Power AI agents across systems' },
];

const freeTrialFTUXFields = [
  {
    name: 'signUpForm',
    type: 'reference',
    model: 'marketo-forms',
    helperText:
      'Pick the existing Free Trial Marketo form. Used for the visible Step 1 sign-up. Ask Nicole if missing.',
  },
  {
    name: 'enrichmentForm',
    type: 'reference',
    model: 'marketo-forms',
    helperText:
      'Pick the new Onboarding Quiz Enrichment Marketo form. Used for silent submits on Steps 2-5 to enrich the lead created by the sign-up.',
  },
  {
    name: 'signUpHeading',
    type: 'string',
    defaultValue: 'Start your free trial now',
  },
  {
    name: 'signUpSubheading',
    type: 'longText',
    defaultValue: 'Get instant access to your own Prismatic sandbox.',
  },
  {
    name: 'signUpButtonText',
    type: 'string',
    defaultValue: 'Access my sandbox',
    helperText:
      'Submit button label on the sign-up form. Configured in the Marketo form itself but used as a hint here.',
  },

  {
    name: 'useCaseHeading',
    type: 'string',
    defaultValue: 'Welcome',
  },
  {
    name: 'useCaseDescription',
    type: 'longText',
    defaultValue: 'Tell us a little about yourself so we can send you down the right path.',
  },
  {
    name: 'useCaseQuestion',
    type: 'string',
    defaultValue: "What's your primary use case?",
  },
  {
    name: 'useCaseOptions',
    type: 'list',
    defaultValue: DEFAULT_USE_CASE_OPTIONS,
    subFields: [
      { name: 'id', type: 'string', required: true },
      { name: 'label', type: 'string', required: true },
    ],
    helperText: 'Multiple choice options shown on Step 2. The id is what gets stored in Marketo.',
  },

  {
    name: 'integrationHeading',
    type: 'string',
    defaultValue: 'Welcome',
  },
  {
    name: 'integrationDescription',
    type: 'longText',
    defaultValue: "Tell us a little about what you're building.",
  },
  {
    name: 'integrationQuestion',
    type: 'string',
    defaultValue: 'What integration do you want to build first?',
  },
  {
    name: 'integrationPlaceholder',
    type: 'string',
    defaultValue: 'Microsoft Dynamics 365...',
  },

  {
    name: 'videoHeading',
    type: 'string',
    defaultValue: 'A quick video',
  },
  {
    name: 'videoDescription',
    type: 'longText',
    defaultValue: 'Familiarize yourself with Prismatic terms and get the lay of the land.',
  },
  {
    name: 'videoCaption',
    type: 'string',
    defaultValue: 'Watch a 1 minute Prismatic orientation:',
  },
  {
    name: 'videoSrc',
    type: 'string',
    helperText:
      'YouTube, Vimeo, or direct mp4 URL for the orientation video. Played via the shared VideoCustom molecule.',
  },
  {
    ...imageField('videoThumbnail'),
    helperText: 'Optional thumbnail shown before the user clicks play. Falls back to a teal placeholder if empty.',
  },

  {
    name: 'thankYouUrl',
    type: 'url',
    defaultValue: '/lp/free-trial-thank-you/',
    helperText:
      'Standalone thank-you page the flow redirects to after the final step. Must be a distinct URL for conversion tracking. Follow the convention of the other Thank You pages.',
  },

  {
    name: 'nextButtonText',
    type: 'string',
    defaultValue: 'Next',
  },
  {
    name: 'skipButtonText',
    type: 'string',
    defaultValue: 'Skip',
  },

  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const freeTrialFTUXConfig = {
  name: 'FreeTrialFTUX',
  inputs: freeTrialFTUXFields,
  defaultStyles: {
    minHeight: '100dvh',
    paddingTop: '0',
    paddingBottom: '0',
  },
};

export type FreeTrialFTUXProps = GenerateBuilder<typeof freeTrialFTUXFields>;

export default freeTrialFTUXConfig;
